<template>
  <stripe-payment-deferred
    v-if="isDeferredPayment"
    :deposit="deposit"
    :remainder="remainder"
    :balance-due-date="balanceDueDate"
    :campsite-name="campsiteName"
    :deposit-percent="depositPercent"
  />
  <stripe-payment-immediate
    v-else-if="isImmediatePayment"
    :campsite-name="campsiteName"
    :deposit-percent="depositPercent"
    :price="price"
    :balance-due-date="balanceDueDate"
    :refund-until-date="refundUntilDate"
    :campsite-refund-policy="campsiteRefundPolicy"
  />
  <stripe-payment-pitchup-only
    v-else-if="isPitchupOnlyPayment"
    :deposit="deposit"
    :remainder="remainder"
    :campsite-name="campsiteName"
    :campsite-payment-timing="campsitePaymentTiming"
    :balance-due-date="balanceDueDate"
    :deposit-percent="depositPercent"
  />
</template>

<script lang="ts">
import type { PaymentTiming } from '../../../../../campsite-details/types'
import type { StripePaymentWhen } from '../../../../types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { SimpleMoney } from '~/utility/money'

@Component
class StripePayment extends Vue {
  @Prop({ required: true })
  campsiteName: string

  @Prop({ required: true })
  stripePaymentWhen: StripePaymentWhen

  @Prop()
  price: SimpleMoney

  @Prop({ required: true })
  deposit: SimpleMoney

  @Prop({ required: true })
  remainder: SimpleMoney

  @Prop({ required: true, type: String })
  campsitePaymentTiming: PaymentTiming

  @Prop()
  balanceDueDate: string

  @Prop({ default: 0.15 })
  depositPercent: number

  @Prop()
  refundUntilDate: string

  @Prop()
  campsiteRefundPolicy: string

  get isDeferredPayment() {
    return this.stripePaymentWhen === 'deferred_payment'
  }

  get isImmediatePayment() {
    return this.stripePaymentWhen === 'immediate_payment'
  }

  get isPitchupOnlyPayment() {
    return this.stripePaymentWhen === 'pitchup_only'
  }
}

export default toNative(StripePayment)
</script>
<style>
@import url('~/assets/css/payment-due.css');
</style>
